import { IconExternalLink } from "@tabler/icons-react";

/** Link a documentación externa con ícono de "open in new tab". */
export function ResourceLink({ label, href, external }: { label: string; href: string; external?: boolean }) {
  return (
    <a
      href={href}
      target={external ? "_blank" : undefined}
      rel={external ? "noreferrer" : undefined}
      className="flex items-center justify-between rounded-md px-2 py-1.5 text-[13px] text-foreground transition-colors hover:bg-muted"
    >
      <span>{label}</span>
      <IconExternalLink size={12} stroke={1.6} className="opacity-40" />
    </a>
  );
}
